import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

export default class extends Controller {
  static targets = ["query"]

  initialize() {
    var results = document.getElementById('asset-search-result');
    if (typeof (results) == 'undefined' || results == null) {
      this.element.requestSubmit()
    }
  }

  connect() {
    this.debouncedSubmit = debounce(() => {
      this.element.requestSubmit()
    }, 500)
  }

  search() {
    this.debouncedSubmit()
  }

  handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.search()
    }
  }
}